import { render } from "./ArchiveLectureView.vue?vue&type=template&id=d0e7c934&scoped=true"
import script from "./ArchiveLectureView.vue?vue&type=script&lang=js"
export * from "./ArchiveLectureView.vue?vue&type=script&lang=js"

import "./ArchiveLectureView.vue?vue&type=style&index=0&id=d0e7c934&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0e7c934"]])

export default __exports__